import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../contexts/userContext";
import MenuList from "../components/MenuList";
import CreateQRModal from "../components/CreateQRModal";

const Menu = () => {
  const { businessData } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (businessData.uid) setLoading(false);
  }, [businessData]);

  return (
    <Grid width="100%" container display="flex" p={3} mt={10}>
      {loading ? (
        <Grid size={12} display="flex" justifyContent="center" mt={3}>
          <CircularProgress size={120} />
        </Grid>
      ) : (
        <>
          <Grid size={12} display="flex" justifyContent="space-between">
            <Typography fontSize={24}>Menu de {businessData.name}</Typography>
            <Button variant="contained" onClick={() => setOpen(true)}>
              Generar QR
            </Button>
          </Grid>
          <MenuList business={businessData} />

          {open && (
            <CreateQRModal open={open} handleClose={() => setOpen(false)} />
          )}
        </>
      )}
    </Grid>
  );
};

export default Menu;
